<template>
  <a href="https://bs-app.s3.amazonaws.com/public/bx-terms.pdf" target="_blank" class="terms">{{text}}</a>
</template>

<script>

export default {
  name: 'TermsLink',
  props: {
    text: {
      type:     String,
      default:  'Terms'
    }
  }
}
</script>

<style lang="scss">

</style>



// WEBPACK FOOTER //
// src/components/utilities/TermsLink.vue